import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SuspendedAccount = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 text-center">
      <div className="bg-white p-10 rounded-[3rem] shadow-xl border border-slate-100 max-w-lg">
        <div className="bg-red-50 text-red-500 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6">
          <ShieldAlert size={40} />
        </div>
        <h1 className="text-3xl font-black text-slate-900 mb-4">Accès Suspendu</h1>
        <p className="text-slate-500 font-medium leading-relaxed mb-8">
          Désolé, l'accès à votre établissement a été temporairement désactivé par la plateforme SamaSalon.
        </p>
        <div className="bg-slate-50 p-4 rounded-2xl border border-slate-100 text-sm font-bold text-slate-600">
          Veuillez contacter l'administrateur du site pour régulariser votre situation.
        </div>
        <button
          onClick={() => navigate('/login')}
          className="mt-8 text-blue-600 font-bold hover:underline"
        >
          Retour à la page de connexion
        </button>
      </div>
    </div>
  );
};

export default SuspendedAccount;
